import React, { useContext } from 'react'
import classnames from 'classnames'
import { checkPermission } from 'utils/permission'
import { StyledButton, Arrow } from './style'
import { I18nContext } from 'i18n'

const ButtonLabel = ({ disabled, permissions, children, ...rest }) => {
  const { translate } = useContext(I18nContext)
  const forbidden = permissions && !checkPermission(permissions)
  const isDisabled = disabled || forbidden

  return (
    <StyledButton
      disabled={isDisabled}
      className={classnames({ clickable: !isDisabled })}
      title={forbidden ? translate('forbidden') : null}
      {...rest}
    >
      {children} <Arrow/>
    </StyledButton>
  )
}

export default ButtonLabel
